(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jb-pdp-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.jb-pdp-wrap');
  roots.forEach(function(root){
    var thumbs = root.querySelectorAll('#jbpdp-thumbs .jbx-gallery-thumb');
    var mains  = root.querySelectorAll('#jbpdp-main img');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        thumbs.forEach(function(x){x.classList.remove('jbx-active');});
        t.classList.add('jbx-active');
        mains.forEach(function(i){i.classList.remove('jbx-active');});
        var m = root.querySelector('#jbpdp-main img[data-img="'+t.dataset.img+'"]');
        if (m) m.classList.add('jbx-active');
      });
    });
    root.querySelectorAll('.jbx-system-cards').forEach(function(group){
      var cards = group.querySelectorAll('.jbx-system-card');
      var label = group.parentElement.querySelector('[data-opt-val]');
      cards.forEach(function(c){
        c.addEventListener('click', function(){
          cards.forEach(function(x){x.classList.remove('jbx-active');});
          c.classList.add('jbx-active');
          if (label) label.textContent = c.dataset.system;
        });
      });
    });
    root.querySelectorAll('.jbx-swatches').forEach(function(group){
      var sw = group.querySelectorAll('.jbx-swatch');
      var label = group.parentElement.querySelector('[data-opt-val]');
      sw.forEach(function(s){
        s.addEventListener('click', function(){
          sw.forEach(function(x){x.classList.remove('jbx-active');});
          s.classList.add('jbx-active');
          if (label) label.textContent = s.dataset.finish;
        });
      });
    });
    root.querySelectorAll('.jbx-size-chips').forEach(function(group){
      var chips = group.querySelectorAll('.jbx-size-chip');
      var label = group.parentElement.querySelector('[data-opt-val]');
      chips.forEach(function(c){
        c.addEventListener('click', function(){
          chips.forEach(function(x){x.classList.remove('jbx-active');});
          c.classList.add('jbx-active');
          if (label) label.textContent = c.textContent;
        });
      });
    });
    var qty = root.querySelector('#jbpdp-qty');
    root.querySelectorAll('[data-qty]').forEach(function(b){
      b.addEventListener('click', function(){
        if (!qty) return;
        qty.value = Math.max(1, parseInt(qty.value || '1') + parseInt(b.dataset.qty));
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
